import { render } from "./concept-section.vue?vue&type=template&id=0ba2223e"
import script from "./concept-section.vue?vue&type=script&lang=js"
export * from "./concept-section.vue?vue&type=script&lang=js"

import "./concept-section.vue?vue&type=style&index=0&id=0ba2223e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__